import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import { connect } from 'react-redux';

import pencil_big from '../../../icons/pencil_big.svg';
import arrowOpen from '../../../icons/arrow-open.svg';
import arrowClose from '../../../icons/arrow-close.svg';
import { IdentificationActionEnum } from '../../../Constant';
import { reportDWH } from '../../../PersonalAreaInvoicesSlice';


function PersonalDetails(props) {
  const [isOpenArrow, setIsOpenArrow] = useState(false);
  const fullName = (`${props.banDetails?.paymentFirstName ? props.banDetails?.paymentFirstName : '' } ${props.banDetails?.paymentLastName  ? props.banDetails?.paymentLastName : '' }`)?.trim();

  if (!props.banDetails) {
    return null;
  }

  const clickArrow = () => {
    setIsOpenArrow(!isOpenArrow);
  };

  const onClick = (type)=>{
    if(type === "DISPLAY_TAX_INVOICE"){
      props.reportDWH({ actionType: 'Invoice Page', status: 'Completed', messageText:'Invoice PDF Download' });
      props.onClickPdfInvoice(IdentificationActionEnum.DISPLAY_TAX_INVOICE, props.guidId, props.systemSourcePDF);
    }else if(type === "DISPLAY_ACCESSIBLE_INVOICE"){
      props.reportDWH({ actionType: 'Invoice Page', status: 'Completed', messageText: 'Accessibility PDF Download' });
      props.onClickPdfInvoice(IdentificationActionEnum.DISPLAY_ACCESSIBLE_INVOICE, props.guidId, props.systemSourcePDF);
    }
  };

  return (
    <div className='wrapper-personal-details'>
      <div className='title-buttons'>
        <div className='title'>פירוט חיובים חודשי</div>
        <div className='wrapper-buttons'>
          <button onClick={() => onClick(IdentificationActionEnum.DISPLAY_TAX_INVOICE)}>חשבונית מס</button>
          <button onClick={() => onClick(IdentificationActionEnum.DISPLAY_ACCESSIBLE_INVOICE)}>חשבונית נגישה</button>
        </div>
      </div>
      {props.banDetails?.periodDate && (
        <div className='info'>
          <div className='container-details'>
            <div className='wrapper-details'>
              <div>תאריכי חיוב: {props.billInfo?.billPeriodEndDate} - {props.billInfo?.billPeriodStartDate}</div>
              <div className='email'>
                {props.banDetails?.billMethod == "SM" ? (
                    <div>
                      <span>החשבונית נשלחת בSMS אל:</span>
                      <span className='value'> {props.banDetails?.smsBillDest}
                        <button onClick={() => { props.onClickUpdateMailing() }}>
                          <Image src={pencil_big} alt='icon-pencil' />
                        </button>
                      </span>
                    </div>
                ) : props.banDetails?.billMethod == "RP" ? (
                    <div>
                      <span>החשבונית נשלחת אל:</span>
                      <span className='value'> {props.banDetails?.cityBillDest}
                        <button onClick={() => { props.onClickUpdateMailing() }}>
                          <Image src={pencil_big} alt='icon-pencil' />
                        </button>
                      </span>
                    </div>
                ) : (props.banDetails?.emailBillDest != '' && props.banDetails?.emailBillDest != null) ? (
                     <div>
                      <span>החשבונית נשלחת אל: </span>
                      <span className='value'> {props.banDetails?.emailBillDest}
                        <button onClick={() => { props.onClickUpdateMailing() }}>
                          <Image src={pencil_big} alt='icon-pencil' />
                        </button>
                      </span>
                    </div>
                ) : null }
              </div>
              {isOpenArrow &&
                <div className='personal-information'>
                  <div>{`מספר לקוח: ${props.banDetails.banId}`}</div>
                  {(!props.isEnergy && fullName) && <div>{`החשבונית משולמת על ידי: ${fullName}`}</div>}
                  {(props.isEnergy && props.personalDetails.contractNumber) && <div>{`מספר חשבון חוזה: ${props.personalDetails.contractNumber}`}</div>}
                  {(props.isEnergy && props.personalDetails.address) && <div>{`כתובת החוזה: ${props.personalDetails.address}`}</div>}
                </div>
              }
            </div>
            <button onClick={() => clickArrow()}>
              <Image src={isOpenArrow ? arrowClose : arrowOpen} alt='icon-arrow' />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}


const mapStateToProps = (state) => {
  return {

  };
};

const mapDispatchToProps = {
  reportDWH
};



export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetails);
